const getters = {
    userInfo: state => {
        return state.user.userInfo
    },
    commonData:state => {
        return state.user.commonData
    }
}
export default getters;